import { useEffect, useRef, useState } from 'react';

import axios from 'axios';
import { useSelector } from 'react-redux';

import { accountIdSelector, isAgentSelector } from 'store/user/selectors';
import { fetchAreas } from 'utils/fetchers';

export function useAreasRequest({ targetId, pageType, countryId }) {
  const [areas, setAreas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const accId = useSelector(accountIdSelector);
  const isAgent = useSelector(isAgentSelector);
  const controllerAreasReqRef = useRef(null);

  const processNewAreas = ({ countryId }) => {
    if (controllerAreasReqRef.current) {
      controllerAreasReqRef.current.abort();
    }
    controllerAreasReqRef.current = new AbortController();
    setIsLoading(true);
    fetchAreas(
      {
        accId,
        countryId,
        targetId,
        pageType,
        isAgent,
      },
      { signal: controllerAreasReqRef.current?.signal },
    )
      .then((data) => {
        if (Array.isArray(data)) {
          setAreas(data);
        }
      })
      .catch((err) => {
        if (!(err instanceof axios.Cancel)) throw err;
      })
      .finally(() => setIsLoading(false));
  };

  const onCountryChange = (countryId) => {
    setAreas([]);
    processNewAreas({ countryId });
  };

  useEffect(() => {
    if (countryId) {
      processNewAreas({ countryId });
    }

    return () => {
      if (controllerAreasReqRef.current) {
        controllerAreasReqRef.current.abort();
      }
    };
  }, [accId]);

  return {
    areas,
    areasBeingLoaded: isLoading,
    onCountryChange,
  };
}
